import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_ENDPOINT}/api/material`;

class MaterialService {
    add(formData) {
        return axios.post(`${API_URL}/new`, formData, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`,
              'Content-Type': 'multipart/form-data'
            }
        });
    }
    update(formData) {
        return axios.put(`${API_URL}/update`, formData, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')?.trim()}`,
              'Content-Type': 'multipart/form-data'
            }
        });
    }
}

export default new MaterialService();
